import Rest from "./BaseRest";
import DjangoRest, { integrationsRest } from "./DjanoBaseRest";
import axios from "axios";

const resource = "/companies";
export default {
  FetchCompanies() {
    return Rest.get(`${resource}`);
  },
  FetchCompany(id) {
    return Rest.get(`${resource}/${id}`);
  },
  FetchCompanyV2() {
    return DjangoRest.get(`${resource}/`);
  },
  StoreCompany(company) {
    return Rest.post(`${resource}`, company, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  CreateCompany(company) {
    return DjangoRest.post(`${resource}/create/`, company, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  UpdateCompany(company) {
    return Rest.put(`${resource}/${company.id}`, company);
  },
  DestroyCompany(id) {
    return Rest.delete(`${resource}/${id}`);
  },
  Impersonate(id, payload) {
    return Rest.post(`${resource}/${id}/user/impersonate`, payload);
  },
  StopImpersonate(id) {
    return Rest.get(`${resource}/${id}/user/stop-impersonate`);
  },
  GetBenefitMemberRecords() {
    return DjangoRest.get(`${resource}/unassociated_benefit_member_records/`);
  },
  CreateClaim(payload) {
    return DjangoRest.post(`${resource}/create_claim/`, payload);
  },
  ClaimHistory() {
    return DjangoRest.get(`${resource}/claim_history/`);
  },
  UnredeemBenefit(benefit_id) {
    return DjangoRest.post(`${resource}/unredeem_benefit/`, { benefit_id });
  },
  OverrideBenefits(payload) {
    return DjangoRest.post(`${resource}/override_benefits/`, payload);
  },
  GetInsurances(companyId) {
    return DjangoRest.get(`/insurances/?company=${companyId}`);
  },
  GetPatients(companyId) {
    return DjangoRest.get(`/patients/?company=${companyId}`);
  },
  UpdateInsurance(payload) {
    return DjangoRest.post(`/insurances/update/`, payload);
  },
  GetCompanyIDFromAccountID(accountId) {
    return DjangoRest.get(`/get_company_id_from_account_id/${accountId}`);
  },
  GetCompanyIDFromAccountIDIntegration(accountId) {
    return integrationsRest.get(`/get-company-id-from-account-id?accountID=${accountId}`);
  },
  async GetIntegrationsEnabled(companyId) {
    try {
      const response = await integrationsRest.get(`/show-integrations?practiceID=${companyId}`);
      return response.data;
    } catch (error) {
      //console.error("Error in GetIntegrationsEnabled:", error);
      throw error;
    }
  },
  async GetMatchJobCount(practiceID) {
    try {
      const response = await integrationsRest.get(`/get-match-job-count?practiceId=${practiceID}`);
      return response.data;
    } catch (error) {
      //console.error("Error in GetMatchJobCount:", error);
      throw error;
    }
  },
  async GetMatchJobs(practiceID) {
    try {
      const response = await integrationsRest.get(`/get-match-jobs?practiceId=${practiceID}`);
      return response;
    } catch (error) {
      //console.error("Error in GetMatchJobs:", error);
      throw error;
    }
  },
  async SubmitMatch(jobID, pmsID, overwrite = false, requestData = null) {
    try {
      const response = await integrationsRest.post('/resolve-match-job', requestData || {
        jobID: jobID,
        pmsID: pmsID,
        overwrite: overwrite
      });
      return response.status;
    } catch (error) {
      //console.error('Error submitting match:', error);
      throw error;
    }
  },
  async GetOnePatient(patientID, companyID) {
    try {
      const response = await integrationsRest.get('/get-one-patient', {
        params: {
          patientID: patientID,
          companyID: companyID
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
}
